import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrl } from "../../../../boot";
import axios from "axios";

// get customers

export const getPriceListApi = createAsyncThunk("client/get-productPrice-list", async (data) => {
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.post(`${baseUrl}vancouverapis/admin/productPrice/api/v1/get-productPrice-list`, data, {
      headers: {
        "auth-token": token,
        "Content-Type": "application/json",
      },
    });

    console.log("response of getPriceListApi list", response);
    return response;
  } catch (error) {
    console.error("Error fetching getPriceListApi - ", error);
    throw error;
  }
});

export const ImportPriceListApi = createAsyncThunk("/import-product-pricing", async (data) => {
  const token = localStorage.getItem("authToken");
  try {
    // Set a 10-minute timeout for large file imports
    const response = await axios.post(`${baseUrl}vancouverapis/import-csv/api/v1/import-product-pricing`, data, {
      headers: {
        "auth-token": token,
        // Remove Content-Type to let browser set it automatically for FormData
      },
      timeout: 600000, // 10 minutes in milliseconds
    });

    console.log("response of price import list", response);
    return response.data;
  } catch (error) {
    console.error("Error importing price list - ", error);
    throw error;
  }
});

// get conut
export const getPriceListCountApi = createAsyncThunk("client/productPrice-count", async (data) => {
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.get(`${baseUrl}vancouverapis/admin/productPrice/api/v1/productPrice-count`, {
      headers: {
        "auth-token": token,
        "Content-Type": "application/json",
      },
    });

    console.log("response of getPriceListCountApi list", response);
    return response;
  } catch (error) {
    console.error("Error fetching getPriceListCountApi - ", error);
    throw error;
  }
});

// update price lsit
export const updatePriceListApi = createAsyncThunk("client/update-productPrice-list", async (data) => {
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.put(`${baseUrl}vancouverapis/admin/productPrice/api/v1/update-productPrice/${data.ROWID}`, data, {
      headers: {
        "auth-token": token,
        "Content-Type": "application/json",
      },
    });

    console.log("response of getPriceListApi list", response);
    return response;
  } catch (error) {
    console.error("Error fetching getPriceListApi - ", error);
    throw error;
  }
});

// delete price list
export const deletePriceListApi = createAsyncThunk("client/delete-productPrice-list", async (data) => {
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.delete(`${baseUrl}vancouverapis/admin/productPrice/api/v1/delete-productPrice/${data}`, {
      headers: {
        "auth-token": token,
        "Content-Type": "application/json",
      },
    });

    console.log("response of getPriceListApi list", response);
    return response;
  } catch (error) {
    console.error("Error fetching getPriceListApi - ", error);
    throw error;
  }
});

// create price list
export const createPriceListApi = createAsyncThunk("client/create-productPrice", async (data) => {
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.post(`${baseUrl}vancouverapis/admin/productPrice/api/v1/create-productPrice`, data, {
      headers: {
        "auth-token": token,
        "Content-Type": "application/json",
      },
    });

    console.log("response of getPriceListApi list", response);
    return response;
  } catch (error) {
    console.error("Error fetching getPriceListApi - ", error);
    throw error;
  }
});

// update maping list after import
export const updatePriceListAfterImport = createAsyncThunk("client/update-after-import", async (data) => {
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.get(`${baseUrl}vancouverapis/admin/productPrice/api/v1/update-after-import`, data, {
      headers: {
        "auth-token": token,
        "Content-Type": "application/json",
      },
    });

    console.log("response of getPriceListApi list", response);
    return response;
  } catch (error) {
    console.error("Error fetching getPriceListApi - ", error);
    throw error;
  }
});

// bulk delete price list
export const bulkDeletePriceListApi = async (ids) => {
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.delete(`${baseUrl}vancouverapis/admin/productPrice/api/v1/delete-productPrice`, {
      headers: {
        "auth-token": token,
        "Content-Type": "application/json",
      },
      data: { ids },
    });

    console.log("response of bulk delete price list", response);
    return response;
  } catch (error) {
    console.error("Error bulk deleting price list - ", error);
    throw error;
  }
};
